export default "__VITE_ASSET__DICDqNfF__"